import { FC } from "react";
import InputTemp from "components-new/InputTemp";
import cn from "classnames";
import styles from "./Form.module.sass";
import { isEmpty } from "helpers";
import { InputDate } from "components-new/InputDate/InputDate";
import { Employee } from "pages/EmployeePage/EmployeeCard/model";

interface FormPropsInterface {
	disabledForm: boolean;
	state: Employee;
	changeField: any;
	selectField: any;
	setSupervisorOptions: any;
	search: string;
	setSearch: any;
	organizationsDirectory: any;
	options: any;
}

const Form: FC<FormPropsInterface> = ({
	disabledForm,
	setSearch,
	options,
	organizationsDirectory,
	changeField,
	selectField,
	state,
	search,
}) => {
	return !isEmpty(state) ? (
		<form className={styles.form}>
			<div>
				<div>
					<div className={styles.title}>ФИО и контакты</div>
					<InputTemp
						required={true}
						onChange={changeField}
						className={styles.input}
						label="Фамилия"
						name={"lastName"}
						value={state.lastName}
						disabled={disabledForm}
					/>
					<InputTemp
						required={true}
						className={styles.input}
						label="Имя"
						onChange={changeField}
						name={"firstName"}
						value={state.firstName}
						disabled={disabledForm}
					/>
					<InputTemp
						required={true}
						className={styles.input}
						label="Отчество"
						onChange={changeField}
						name={"middleName"}
						value={state.middleName}
						disabled={disabledForm}
					/>
					<InputTemp
						type={"phone"}
						className={styles.input}
						label="Номер телефона"
						onChange={changeField}
						name={"phone"}
						value={state.phone}
						disabled={disabledForm}
					/>
					<InputTemp
						className={styles.input}
						label="Почта"
						onChange={changeField}
						name={"email"}
						disabled={disabledForm}
						value={state.email}
					/>
				</div>
				<div>
					<div className={cn(styles.title, styles.specialTitle)}>Руководитель</div>
					<InputTemp
						className={styles.input}
						onChange={(e) => {
							const { value } = e.target;
							setSearch(value);
						}}
						onSelect={(e) => {
							selectField("supervisor", e);
							setSearch(e.fullName);
						}}
						remote={{
							link: "/employees/short",
							initialParams: {
								page: 1,
								num: 20,
							},
						}}
						field={["fullName", "id"]}
						label="ФИО руководителя"
						name={"supervisor"}
						value={search}
						disabled={disabledForm}
					/>
					<InputTemp
						readOnly={true}
						className={styles.input}
						label="Должность руководителя"
						value={state.supervisor ? state.supervisor.position : ""}
						disabled={true}
					/>
				</div>
			</div>

			<div>
				<div className={styles.title}>Отношения с организацией</div>
				<InputTemp
					className={styles.input}
					required={true}
					label="Организация-работодатель"
					onSelect={(e: any) => selectField("organization", e)}
					type={"select"}
					options={organizationsDirectory}
					filter={true}
					field={"shortName"}
					value={state.organization?.shortName || ""}
					disabled={disabledForm}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					label="Вид отношений с организацией"
					onSelect={(e: any) => selectField("relationship", e)}
					type={"select"}
					field={"name"}
					options={options.relationship}
					value={state.relationship?.name}
					disabled={disabledForm}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					label="Табельный номер"
					onChange={changeField}
					name={"tabNumber"}
					value={state.tabNumber}
					disabled={disabledForm}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					label="Должность"
					isCreated={true}
					name={"position"}
					onSelect={(e: any) => selectField("position", e.name)}
					onChange={changeField}
					field={"name"}
					filter={true}
					options={options.position}
					value={state.position}
					disabled={disabledForm}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					label="Подразделение"
					isCreated={true}
					onChange={changeField}
					onSelect={(e: any) => selectField("department", e.name)}
					name={"department"}
					field={"name"}
					filter={true}
					options={options.department}
					value={state.department}
					disabled={disabledForm}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					label="Статус"
					disabled={disabledForm}
					type={"select"}
					onSelect={(e: any) => selectField("status", e)}
					field={"name"}
					remote={{
						link: "/directory/person/status/list",
						initialParams: {},
					}}
					filter={true}
					// options={[]}
					value={state.status?.name}
				/>
				{disabledForm ? (
					<InputTemp
						required={true}
						className={styles.input}
						label="Дата приема на работу сотрудника"
						value={state.employmentDate?.replace(/(\d{4})-(\d{2})-(\d{2})/g, "$3.$2.$1")}
						disabled={disabledForm}
					/>
				) : (
					<InputDate
						required={true}
						onChange={changeField}
						name={"employmentDate"}
						className={styles.input}
						title="Дата приема на работу сотрудника"
						value={state.employmentDate}
					/>
				)}
				{disabledForm ? (
					<InputTemp
						className={styles.input}
						label="Дата увольнения сотрудника"
						value={state.dismissalDate?.replace(/(\d{4})-(\d{2})-(\d{2})/g, "$3.$2.$1")}
						disabled={disabledForm}
					/>
				) : (
					<InputDate
						className={styles.input}
						onChange={changeField}
						name={"dismissalDate"}
						title="Дата увольнения сотрудника"
						value={state.dismissalDate}
					/>
				)}
			</div>
		</form>
	) : null;
};

export default Form;
